import React from 'react';

interface DepartmentStat {
  key: string;
  label: string;
  count: number;
  color: string;
  bgColor: string;
  borderColor: string;
  icon: React.ReactNode;
}

interface DepartmentFilterRowProps {
  selectedDept: string;
  onDeptChange: (dept: string) => void;
  departments: DepartmentStat[];
  totalCount: number;
}

export function DepartmentFilterRow({
  selectedDept,
  onDeptChange,
  departments,
  totalCount,
}: DepartmentFilterRowProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border-b border-[#E8E8F5]/50 pb-2">
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="mr-1 text-xs font-medium text-[#747C9C]">Departments:</span>
        <button
          type="button"
          onClick={() => onDeptChange('all')}
          className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
            selectedDept === 'all'
              ? 'bg-[#6825F5] text-white shadow-sm'
              : 'border border-[#E8E8F5] bg-[#FFFFFF] text-[#747C9C] hover:bg-[#F2F2FA]'
          }`}
        >
          All ({totalCount})
        </button>
        {departments.map((d) => (
          <button
            key={d.key}
            type="button"
            onClick={() => onDeptChange(d.key)}
            className={`flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
              selectedDept === d.key
                ? 'bg-[#6825F5] text-white shadow-sm'
                : 'border border-[#E8E8F5] bg-[#FFFFFF] text-[#747C9C] hover:bg-[#F2F2FA]'
            }`}
          >
            <span style={{ color: d.color }}>{d.icon}</span>
            <span>{d.label}</span>
            <span
              className={`rounded-full px-1.5 py-0.2 text-[10px] ${
                selectedDept === d.key ? 'bg-white/20 text-white' : 'bg-[#F2F2FA] text-[#747C9C]'
              }`}
            >
              {d.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}